function MinusIcon({ dimension }: any) {
  return (
    <svg
      width={dimension || "20px"}
      height={dimension || "20px"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path d="M1 10L1 6L15 6V10L1 10Z" fill="#000000"></path>{" "}
      </g>
    </svg>
  );
}

export { MinusIcon };
